import elementCreation from '../elementCreation';
import get from '../../../../helpers/get';
class HeaderComponent {
    constructor(OS_DATA, headerContainer, emitter, monthlyPayment) {
        this.OS_DATA = OS_DATA;
        this.emitter = emitter;
        this.firstRender = true;
        this.monthlyPayment = monthlyPayment;
        this.errorHeader = headerContainer.querySelector('.payment-details__error-container');
        this.loadingHeader = headerContainer.querySelector('.payment-details__loading-container');
        this.paymentHeader = headerContainer.querySelector('.payment-details__payment-container');
        this.paymentOptionButtonContainer = document.querySelector('[modal-id="online-shopper-modal"] .payment-details__options');
        this.itemizedDisclaimer = document.querySelector('[modal-id="online-shopper-modal"] .payment-details__legal-itemized-copy');
        this.detailsDisclaimer = document.querySelector('.payment-details__legal-details-copy');
        this.isItemizedPriceOpen = false;
        this.headerObject = {
            monthlyPayment: this.paymentHeader.querySelector('.monthly-payment'),
            info: this.paymentHeader.querySelector('.info'),
            itemizedCta: this.paymentHeader.querySelector('.itemized-cta')
        };

        this._quickHeaderRender();

        this.emitter.on('new-vehicle-state', (vehicleState, personData) => {
            this.update(vehicleState, personData, this.paymentsSettings);
        });

        this.emitter.on('new-offers', vehicleState => {
            this.update(vehicleState, this.personData, this.paymentsSettings);
        });

        this.emitter.on('itemized-price-toggled', isOpen => {
            this.isItemizedPriceOpen = isOpen;
        });
    }
    /* istanbul ignore next */
    update(vehicleState, personData, paymentsSettings) {
        this.personData = personData;
        this.paymentsSettings = paymentsSettings;
        if (vehicleState) {
            this.vehicleState = vehicleState;
            this.selected = vehicleState.payments.selected;
        }
        if (personData && personData.credit_estimate) {
            this.creditEstimate = personData.credit_estimate;
        } else {
            this.creditEstimate = this.paymentsSettings.finance_settings.credit_rating.default;
        }
        const offers = this.vehicleState.payments[this.selected].offers;
        const selectedOffer = this.vehicleState.payments[this.selected].selected_offer;
        const currentOptionData = vehicleState.payments[this.selected];
        if (!this.firstRender) {
            if (this._hashesMatch() && offers) {
                this._removeLoadAnimation();
                if (offers[selectedOffer]) {
                    this.itemizedDisclaimer.innerHTML = elementCreation.makeItemizedDisclaimerText(this.selected, offers[selectedOffer].lender, this.creditEstimate);
                    this.errorHeader.classList.add('hidden');
                    const calculatedPaymentText = elementCreation.calculatedPaymentText(this.vehicleState.payments, this.vehicleState.payments.selected, this.isItemizedPriceOpen, this.firstRender, true);
                    this.headerObject.monthlyPayment.innerHTML = calculatedPaymentText[0];
                    this.headerObject.info.innerHTML = calculatedPaymentText[1];
                    this.headerObject.itemizedCta.innerHTML = calculatedPaymentText[2];
                    this.emitter.emit('header-component-rerendered', this.vehicleState, this.selected, this.OS_DATA);
                    this.detailsDisclaimer.innerHTML = elementCreation.makeDetailsDisclaimerText(this.selected, currentOptionData);
                } else {
                    this._displayErrorState(this.errorHeader, this.paymentHeader);
                }
            } else {
                this._displayLoadAnimation();
            }
        } else {
            this.firstRender = false;
        }
    }

    _quickHeaderRender() {
        let selected, goodDeal;
        const entireDeal = get(this.monthlyPayment, 'loan.offers');

        if (entireDeal) {
            selected = this.monthlyPayment.selected;
            goodDeal = get(this.monthlyPayment, 'loan.offers[0]');
        } else {
            selected = 'loan';
            goodDeal = true;
        }
        if (goodDeal) {
            const calculatedPaymentText = elementCreation.calculatedPaymentText(this.monthlyPayment, selected, this.isItemizedPriceOpen, this.firstRender, entireDeal);
            this._removeLoadAnimation();
            this.headerObject.monthlyPayment.innerHTML = calculatedPaymentText[0];
            this.headerObject.info.innerHTML = calculatedPaymentText[1];
            this.headerObject.itemizedCta.innerHTML = calculatedPaymentText[2];
        } else {
            this._removeLoadAnimation();
            this._displayErrorState();
        }
    }

    _hashesMatch() {
        return this.vehicleState.payments[this.selected].data_hash === this.vehicleState.payments[this.selected].request_hash;
    }

    _displayErrorState() {
        this.errorHeader.classList.remove('hidden');
        this.paymentHeader.classList.add('hidden');
    }

    _removeLoadAnimation() {
        this.loadingHeader.classList.add('hidden');
        this.paymentHeader.classList.remove('hidden');
        this.errorHeader.classList.add('hidden');
    }

    _displayLoadAnimation() {
        this.loadingHeader.classList.remove('hidden');
        this.paymentHeader.classList.add('hidden');
        this.errorHeader.classList.add('hidden');
    }
}

export default HeaderComponent;